import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import { IconButton, Modal as MuiModal } from '@material-ui/core'
import clsx from 'clsx'
import { createUseStyles } from 'react-jss'
import Backdrop from '@material-ui/core/Backdrop'
import Fade from '@material-ui/core/Fade'
import CloseIcon from '@material-ui/icons/Close'
import Button from '../Button'
// import { useIsMounted } from '../Hooks/UseIsMounted'

const useJssStyles = createUseStyles(
  {
    'modal-container': {
      top: (props) => props.top + '%',
      left: (props) => props.left + '%',
      transform: (props) =>
        props.fullscreen
          ? `translate(-${props.left}%, -${props.top}%)`
          : `translate(-${props.left}%, -${props.top - props.offset}%)`,
      width: (props) =>
        props.fullscreen ? '100%' : props.width + (props.px ? 'px' : '%'),
      height: (props) =>
        props.fullscreen ? '100%' : props.height + (props.px ? 'px' : '%'),
      outline: 'none'
    }
  },
  { name: 'bund-' }
)

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    boxShadow: theme.shadows[5],
    outline: 'none'
  },
  iconButton: {
    padding: 0,
    outline: 'none',
    position: 'absolute',
    '&:focus': {
      outline: 'none'
    }
  }
}))

export const Modal = (props) => {
  const {
    title,
    description,
    children,
    style,
    push,
    type,
    search,
    from,
    edit,
    width,
    height,
    fullscreen,
    px,
    top,
    left,
    offset,
    position,
    close,
    padding,
    nav,
    icon,
    openText,
    index,
    buttonColor,
    buttonVariant,
    buttonStyle,
    buttonShape,
    buttonSize,
    buttonPadding,
    buttonMargin,
    scroll,
    ...rest
  } = props

  const [open, setOpen] = useState(false)
  const [selected, setSelected] = useState()
  const history = useHistory()
  const classes = useStyles()
  const jssClasses = useJssStyles(props)
  // const isMounted = useIsMounted()

  const handleOpen = () => {
    if (isMounted.current) {
      setSelected(index)
      setOpen(true)
      if (selected) {
        history.push(push + '/' + type + search)
      }
    }
  }

  const handleClose = () => {
    setOpen(false)
    history.push(from)
  }

  useEffect(() => {
    // if (window.location.pathname === from) {
    //   setOpen(true)
    // }
  }, [open])

  return (
    <div>
      <div>
        <Button
          type="button"
          id={index}
          onClick={handleOpen}
          size={buttonSize}
          shape={buttonShape}
          variant={buttonVariant}
          color={buttonColor}
          style={
            buttonStyle
              ? buttonStyle
              : {
                  alignItems: 'center',
                  display: 'flex',
                  margin: buttonMargin ? buttonMargin : null,
                  padding: buttonPadding ? buttonPadding : null
                }
          }>
          {openText} {icon}
        </Button>
      </div>
      <MuiModal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500
        }}>
        <Fade in={open}>
          <div className={clsx(jssClasses['modal-container'], classes.paper)}>
            <div
              style={{
                borderRadius: fullscreen ? '' : '12px',
                padding: padding,
                overflowX: 'hidden',
                overflowY: scroll ? 'scroll' : 'unset'
              }}
              className="modalPaper">
              <h3 id="modal-title">{title}</h3>
              <p id="modal-description">{description}</p>
              {children}
              {nav && <div>NavBar</div>}
              {close && (
                <IconButton
                  classes={{ root: classes.iconButton }}
                  aria-label="close"
                  size="small"
                  className="text-color"
                  style={{
                    right: fullscreen ? -left + 32 : left - 28,
                    top: top
                  }}
                  onClick={handleClose}
                  size="small"
                  aria-label="logout"
                  type="submit">
                  <CloseIcon />
                </IconButton>
              )}
            </div>
          </div>
        </Fade>
      </MuiModal>
    </div>
  )
}

Modal.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.node.isRequired,
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  close: PropTypes.bool,
  type: PropTypes.string, // 'edit', 'comment', 'message', 'reply', 'send', 'write', 'read', 'fwd', 'submit','attach'
  search: PropTypes.string,
  from: PropTypes.string,
  push: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  position: PropTypes.string,
  px: PropTypes.bool,
  top: PropTypes.number,
  left: PropTypes.number,
  offset: PropTypes.number,
  fullscreen: PropTypes.bool,
  padding: PropTypes.string,
  nav: PropTypes.bool,
  openText: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  icon: PropTypes.object,
  index: PropTypes.number,
  buttonVariant: PropTypes.string,
  buttonColor: PropTypes.string,
  buttonStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  buttonPadding: PropTypes.string,
  buttonMargin: PropTypes.string,
  scroll: PropTypes.bool
}

Modal.defaultProps = {
  width: 92,
  height: 92,
  top: 8,
  left: 20,
  offset: 0,
  padding: '16px 32px 24px',
  index: 0,
  buttonShape: 'square',
  buttonVariant: 'outline',
  buttonColor: 'primary',
  buttonSize: 'sm'
}

Modal.displayName = 'm'

export default Modal
